import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./vendorgrid.css"; // Import custom styles


export const VendorGrid = ({setIsLoading, pcHierData}) => {
  const jsonData = pcHierData;
  // 🔹 Prepare Row Data (excluding Parent Vendor)
  const rowData = useMemo(() =>
    jsonData[0]?.childVendor.map((vendor) => ({
      vendorProfileId: vendor.vendorProfileId,
      childVendorName: vendor.vendorCorpName, // 🔹 Child Vendor Name
      duns: vendor.duns,
      partnerId: vendor.partnerId,
      relationshipType: vendor.relationshipType,
      dvns: vendor.dvns,
      isExpandable: vendor?.dvns?.length > 0,
      isParent: false, // Not a parent row
    })) || []
    , [jsonData]);

  // 🔹 Pinned Row Data (Parent Vendor)
  const pinnedTopRowData = useMemo(() => [
    {
      vendorProfileId: jsonData[0]?.parentVendor.vendorProfileId,
      parentVendorName: jsonData[0]?.parentVendor.vendorCorpName, // 🔹 Parent Vendor Name
      duns: jsonData[0]?.parentVendor.duns,
      partnerId: jsonData[0]?.parentVendor.partnerId,
      isParent: true, // Identifies as parent
    },
  ], [jsonData]);

  // 🔹 Column Definitions
  const columnDefs = useMemo(
    () => [
      {
        field: "parentVendorName",
        headerName: "Parent Vendor Name",
        rowGroup: true, // 🔹 Group by Parent Vendor
        hide: false, // Show Parent Name column
        flex: 1,
        sortable: true, filter: true
      },
      {
        field: "childVendorName",
        headerName: "Child Vendor Name",
        cellRenderer: "agGroupCellRenderer",
        cellRendererParams: (params) => ({
          suppressCount: !params.data?.isExpandable, // Hide expand icon if no DVNs
        }),
        flex: 1,
        sortable: true, filter: true
      },
      { field: "duns", headerName: "DUNS", flex: 1,sortable: true, filter: true },
      { field: "relationshipType", headerName: "Relationship Type", flex: 2,sortable: true, filter: true },
    ],
    []
  );

  const selectedDVNRenderer = (props) => {
    console.log(props.data);
    return (
      <input type="checkbox" name="selectedDvn" disabled checked={props?.data?.isChecked} />
    )
  }

   // Detail Table Columns
 const detailColumnDefs = [
  { field: "isChecked", headerName: "Selected DVN", cellRenderer: selectedDVNRenderer, filter: true, sortable: true },
  { field: "dvnName", headerName: "DVN Name", hide:  true, filter: true, sortable: true },
  { field: "operatingDivision", headerName: "Operating Division", filter: true, sortable: true },
  { field: "deptNumber", headerName: "Department Number", filter: true, sortable: true },
  { field: "vendorNumber", headerName: "Vendor Number", filter: true, sortable: true },
];

  // 🔹 Grid Options
  const gridOptions = {
    masterDetail: true,
    isRowMaster: (data) => data.isExpandable,
    getRowStyle: (params) => {
      if (params?.data?.isParent) {
        return { fontWeight: "bold", backgroundColor: "#f0f0f0" }; // Highlight Parent Vendor Row
      }
      return null;
    },
    groupDefaultExpanded: 0, // 🔹 Keep child vendors collapsed initially
   autoGroupColumnDef: {
     headerName: "Vendor Hierarchy",
     field: "childVendorName",
     cellRenderer: "agGroupCellRenderer",
   },
   detailCellRendererParams: (params) => ({
     detailGridOptions: {
       columnDefs: detailColumnDefs,
       defaultColDef: { flex: 1, sortable: true, resizable: true },
     },
     getDetailRowData: (params) => {
       params.successCallback(params.data.dvns || []);
       setIsLoading(false);
     },
   }),
  };

  return (
    <div className="ag-theme-alpine custom-ag-grid" style={{ height: "500px", width: "100%" }}>
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        gridOptions={gridOptions}
        pinnedTopRowData={pinnedTopRowData} 
        getRowId={(params) => params.data.vendorProfileId}
        animateRows={true}
        groupDisplayType="groupRows"
        pagination={true}  // Enables pagination
        paginationPageSize={8} // Sets page size
        paginationPageSizeSelector={[3, 5, 10]} // Allows users to select page size
      />
    </div>
  );
}; 